import React from 'react';
import PropTypes from 'prop-types';

export const Markets = ({ width, height, ...props }) => (
  <svg
    data-icon='markets'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M4 6V4h16v2H4Zm0 14v-6H3v-2l1-5h16l1 5v2h-1v6h-2v-6h-4v6H4Zm2-2h6v-4H6v4Zm-.95-6h13.9l-.6-3H5.65l-.6 3Z'
    />
  </svg>
);

Markets.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Markets.defaultProps = {
  width: 24,
  height: 24,
};
